import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first, groupBy } from 'lodash';
import {
  FileStatus,
  FileType,
  FileTypeLabel,
  RFQStatus,
  RFQStatusLabel,
  TemplateType,
  UserType,
} from 'src/app/shared/constants/constants';
import { downloadFiles, getRFQTemplateLabel } from 'src/app/shared/utils';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { RfqService } from '../services/rfq.service';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

interface RFQInfo {
  id: number;
  rfqName: string;
}
interface DocumentDetails {
  userType: string;
  documentUseFor: string;
  baseUrl: string;
}

@Component({
  selector: 'app-rfq-detail',
  templateUrl: './rfq-detail.component.html',
  styleUrls: ['./rfq-detail.component.scss'],
})
export class RfqDetailComponent {
  baseUrl = environment.BASE_URL;
  @Input() rfqInfo!: RFQInfo;
  rfqItem: any;
  attachedFiles: any[] = [];
  attachments: any[] = [];
  fileTypeGroup: Map<string, any> = new Map();
  FileTypeLabel: any = FileTypeLabel;

  RFQStatusLabel: any = RFQStatusLabel;
  RFQStatus: any = RFQStatus;
  FileType: any = FileType;
  fileStatus: any = FileStatus;
  templateType = TemplateType;
  UserType: any = UserType;

  Sendarchive: boolean = false;
  isMoreExpanded: boolean = false;
  saveButtonEnable: boolean = true;
  isExpanded: boolean = false;

  archivedPOFile: any;
  lineItems: any;
  custRfqId: any;
  companyId = sessionStorage.getItem('customercompanyId') || '';
  customerName!: string;

  resetFileUpload: boolean = false;
  documentInfo: DocumentDetails = {
    userType: UserType.Customer,
    documentUseFor: FileType.RFQ,
    baseUrl: this.baseUrl,
  };
  fileUploadConfig = {
    uploadLabel: 'Upload New Files',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File .xls, .xlsx,',
    isMultiple: true,
    fileSizeLimit: 10485760 * 10, // 100 mb in bytes
    fileLocation: `${UserType.Customer}/${this.companyId}/tooling`,
    fileFormats: '.xls, .xlsx', // supported file formats for file picker
  };

  pdcDocumentInfo: DocumentDetails = {
    userType: UserType.Customer,
    documentUseFor: FileType.PDC,
    baseUrl: this.baseUrl,
  };
  pdcFileUploadConfig = {
    uploadLabel: 'Upload Post Dated Cheque (PDC) File',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File .jpeg, .jpg, .png, .pdf, .doc, .docx, .zip',
    isMultiple: true,
    fileSizeLimit: 10485760 * 1, // 10 mb in bytes
    fileLocation: `${UserType.Customer}/${this.companyId}/tooling`,
    fileFormats: '.jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP', // supported file formats for file picker
  };

  pdcFiles: any[] = [];
  pdcDetailsForm!: FormGroup;
  todayDate = new Date().toISOString().split('T')[0];
  currencyData: any[] = [];
  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private rfqService: RfqService
  ) {}

  ngOnInit() {
    this.getRfqCustomerDetail(this.rfqInfo.id);
    this.getCustomerName();
  }

  createPdcForm(rfqItem: any) {
    this.pdcDetailsForm = new FormGroup({
      pdcAmount: new FormControl(rfqItem?.customerPDCAmount || 0, Validators.required),
      dueDate: new FormControl(rfqItem?.customerPDCDueDate || this.todayDate, Validators.required),
      customerPDCCurrency: new FormControl(rfqItem?.customerPDCCurrency || "INR", Validators.required),
      poNumber: new FormControl(rfqItem?.poNo || '', Validators.required),
      poDate: new FormControl(rfqItem?.poDate || this.todayDate, Validators.required),
    });
  }

  getCurrencyData() {
    let payload = {dataTypes: ['currency'],};
    const apiUrl = `${this.baseUrl}common-service/api/master-data`;
    this.http.post(apiUrl, payload).subscribe({
      next: (data: any) => {
        this.currencyData = data.response.data?.currency
      },
      error: (error) => {
        this.toastr.error(error.error.status.error.message);
      }
    });
  }
  disableFutureDates = (date: Date | null): boolean => {
    const today = new Date();
    if (!date) return true;
    return date <= today;
  };

  close = () => {};
  updateRfqListData = () => {};
  getRfqCustomerDetail(customerRfqPrimaryId: number) {
    this.rfqService.getCustomerRfq(customerRfqPrimaryId).subscribe({
      next: (data: any) => {
        this.rfqItem = data.response;
        this.createPdcForm(this.rfqItem);
        this.getCurrencyData();
        this.pdcFiles = this.rfqItem.attachments.filter(
          (file: any) => {
            return file.fileType == FileType.PDC && file.fileStatus == FileStatus.Live;
          }
        );
        this.archivedPOFile = data.response.attachments.filter(
          (file: { fileStatus: string; fileType: string }) => {
            return (
              file.fileStatus == FileStatus.Archive &&
              file.fileType == FileType.PO
            );
          }
        );
        this.attachedFiles = this.rfqItem?.attachments;
        this.groupAttachmentsByFileType(this.rfqItem?.attachments);
        if (this.rfqItem?.status === RFQStatus.QUOTE_ACCEPTED) {
          this.changeLabels();
        }
      },
    });
  }

  getStatusLabel(status: any): string {
    return this.RFQStatusLabel[status];
  }
  getRFQTemplateLabel(rfqType: TemplateType): string {
    return getRFQTemplateLabel(rfqType);
  }
  /**Grouping of files based on file type**/
  getFileTypeLabel(fileType: any): string {
    return this.FileTypeLabel[fileType];
  }
  groupAttachmentsByFileType(filesData: any): any {
    const result: any = groupBy(filesData, 'fileType');
    this.fileTypeGroup = result;
  }
  getFileTypes() {
    return Object.entries(this.fileTypeGroup).map(([key, value]) => ({
      key,
      value,
    }));
  }
  downloadFile(id: number, fileName: string) {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, fileName);
  }
  /**Grouping of files and download**/
  getCustomerName() {
    let apiURL = `${this.baseUrl}customer/company-management/getCompanyDetails?companyId=${this.companyId}`;
    this.commonService.getData(apiURL).subscribe((res) => {
      this.customerName = res.response.name;
    });
  }
  updateRFQFile() {
    let apiURL = `${this.baseUrl}rfq/customer/`;
    const payLoad = {
      customerId: Number(this.companyId),
      customerName: this.customerName,
      rfqTemplate: [first(this.rfqItem.rfqTemplate)],
      secondaryProcess: this.rfqItem.secondaryProcesses,
      material: this.rfqItem.materials,
      category: this.rfqItem.category,
      projectName: this.rfqItem.projectName,
      attachments: this.attachments,
      createdSource: 'portal',
      paymentTerm: this.rfqItem.paymentTerm,
      paymentTermRemarks: this.rfqItem.paymentTermRemarks,
      incoTerm: this.rfqItem.incoTerm,
      address: this.rfqItem.address,
      moq: this.rfqItem.moq,
      deliveryDate: this.rfqItem.deliveryDate,
      countryName: this.rfqItem.countryName,
      categoryOthers : this.rfqItem.categoryOthers,
      materialOthers : this.rfqItem.materialOthers
    };

    let subcategory: [] = this.rfqItem.subCategory;

    if (subcategory) {
      for (let val of subcategory) {
        payLoad.category.push(val);
      }
    }
    this.commonService.update(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }
  acceptQuote() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Accept Quote',
        content: 'Are you sure you want to accept this quote ?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Accept',
        };
        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            this.toastr.success('Quote Accepted Successfully');
            this.updateRfqListData();
          },
          error: (error: HttpErrorResponse) => {
            this.toastr.error(error.error.status.error.message);
          },
        });
      }
    });
  }

  updatePDCFile() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Upload Post Dated Cheque (PDC)',
        content: 'Are you sure you want to upload this PDC file and details?',
        btnConfirm: 'CONFIRM',
        btnCancel: 'CANCEL',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.uploadPDCDetails();
      }
    });
  }

  uploadPDCDetails() {
    const getPdcFile = this.attachments?.find(file => file.fileType === FileType.PDC);
    let attachments = [];
    if(getPdcFile.id) {
      attachments.push(getPdcFile);
    }
    const dueDateValue = new Date(this.pdcDetailsForm.get('dueDate')?.value).toISOString(); // gives yyyy-MM-dd
    let pdcCurrencyEmproCode;
    this.currencyData.forEach(currency => {
      if(currency.currencyType === this.pdcDetailsForm.get('customerPDCCurrency')?.value) {
        pdcCurrencyEmproCode = currency.currencyTypeCode;}
    });
    const payload = {
      customerRfqId: this.rfqItem.customerRfqPrimaryId,
      adminRfqId: this.rfqItem.adminRFQId,
      pdcAmount: Number(this.pdcDetailsForm.get('pdcAmount')?.value),
      pdcDueDate: dueDateValue,
      pdcCurrency: this.pdcDetailsForm.get('customerPDCCurrency')?.value,
      pdcCurrencyEmproCode: pdcCurrencyEmproCode,
      userType: UserType.Customer,
      attachments: attachments
    };
    this.rfqService.updatePDCData(payload).subscribe({
      next: () => {
        this.toastr.success('PDC details saved Successfully');
        this.updateRfqListData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
    });
  }

  updatePOFile() {
    let confirmationMessage = '';
    let confirmationHeading = '';
    const pdcAmount = this.pdcDetailsForm.get('pdcAmount')?.value;
    const poNumber = this.pdcDetailsForm.get('poNumber')?.value;
    const poDate = this.pdcDetailsForm.get('poDate')?.value;
    const pdcDueDate = this.pdcDetailsForm.get('dueDate')?.value;
    if (this.attachments?.some(file => file.fileType === FileType.PDC) && pdcAmount && pdcAmount > 0 && pdcDueDate) {
      confirmationHeading = 'Upload P.O. & Post Dated Cheque (P.D.C.) Details ?';
      confirmationMessage = 'Are you sure you want to continue with this Post Dated Cheque (P.D.C.) details and this P.O. file ?';
    } else {
      confirmationHeading = 'Upload P.O. without Post Dated Cheque (P.D.C.) details ?';
      confirmationMessage = 'Are you sure you want to continue with this P.O. without Post Dated Cheque (P.D.C.) details ?';
    }
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: confirmationHeading,
        content: confirmationMessage,
        btnConfirm: 'CONFIRM',
        btnCancel: 'CANCEL',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const getPoFile = this.attachments?.find(file => file.fileType === FileType.PO);
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          attachments: [
            {
              id: getPoFile?.id,
              fileName: getPoFile?.fileName,
              type: getPoFile?.type,
              location: getPoFile?.location,
              presignedUrl: getPoFile?.presignedUrl,
              rfqTemplateType: getPoFile?.rfqTemplateType,
              size: getPoFile?.size,
              updatedOn: getPoFile?.updatedOn,
              fileType: FileType.PO,
            },
          ],
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Upload',
          poNo: poNumber,
          poDate: new Date(poDate).toISOString(),
        };
        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            if (this.attachments?.some(file => file.fileType === FileType.PDC) && pdcAmount && pdcDueDate) {
              this.uploadPDCDetails();
            }
            this.toastr.success('P.O. Raised Successfully');
            this.updateRfqListData();
          },
        });
      }
    });
  }
  updatePOStatus() {
    let apiURL = `${this.baseUrl}rfq/customer/${this.rfqItem.id}/PO_RAISED`;
    const payLoad = {};
    this.http.post(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }
  changeLabels() {
    this.documentInfo.documentUseFor = FileType.PO;
    this.fileUploadConfig.uploadLabel = 'Upload P.O.';
    (this.fileUploadConfig.isMultiple = false),
      (this.fileUploadConfig.fileFormats = '.xls, .xlsx, .pdf, .XLS, .XLSX, .PDF'),
      (this.fileUploadConfig.dragDropText =
        'Drag & Drop File .xls, .xlsx, .pdf'),
      (this.fileUploadConfig.fileLocation = `${UserType.Customer}/rfq/${this.rfqItem.id}/${this.rfqItem?.rfqTemplate}/po`);
  }

  fileUploadEvent(event: any, fileType: string): void {
    const fileUploadData: any = event;
    if (event?.attachment?.length === 0) {
      for (const element of this.attachments) {
        if (element.fileType === (fileType === 'pdc' ? FileType.PDC : FileType.PO)) {
          this.attachments = this.attachments.filter(file => file !== element);
          // this.pdcFiles = this.pdcFiles.filter(file => file !== element);
          break;
        }
      }
      return;
    }
    let filedata: any[] = fileUploadData?.attachment;
    let fileTypeValue: any;
    if (fileType === 'pdc') {
      fileTypeValue = FileType.PDC;
    } else if (fileType === 'po') {
      fileTypeValue = FileType.PO;
    } else {
      fileTypeValue = FileType.Additional;
    }

    filedata.forEach((dataItem:any)=>{
      let payLoad = {
        id: dataItem?.id,
        fileName: dataItem?.fileName,
        fileType: fileTypeValue,
        rfqTemplateType: first(this.rfqItem.rfqTemplate),
        updatedOn: new Date(),
        fileExtension: dataItem?.type,
        size: dataItem?.size,
        type: '.' + dataItem?.type,
        uploadedBy: UserType.Customer,
        location: dataItem?.location,
        presignedUrl: dataItem?.presignedUrl,
      };
      this.attachments.push(payLoad);
      // this.pdcFiles.push(payLoad);
    })


    if (this.attachments?.length > 0) {
      this.saveButtonEnable = false;
    } else {
      this.saveButtonEnable = true;
    }
  }
  toggleAttachment() {
    (this.fileUploadConfig.fileFormats =
      '.jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .dwg, .dxf, .dgn, .stl , .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP, .DWG, .DXF, .DGN, .STL'),
      (this.fileUploadConfig.dragDropText =
        'JPEG | JPG | PNG | PDF | DOC | DOCX | ZIP | DWG | DXF | DGN | STL | STEP | IGES | STP'),
      (this.isExpanded = !this.isExpanded);
  }

  async downloadAllQuoteFiles(fileList: any): Promise<void> {
    if (fileList?.length > 0) {
      for (const item of fileList) {
        if (
          (item.fileType == FileType.Quote_Tooling ||
            item.fileType == FileType.Quote_Component ||
            item.fileType == FileType.Quote_Capex ||
            item.fileType == FileType.Quote) &&
          item.fileStatus == FileStatus.Live
        ) {
          await this.downloadFile(item.id, item.fileName);
        }
      }
      this.toastr.success(`All files downloaded successfully`);
    }
  }

  get isPoUploaded(): boolean {
    return this.attachments?.some(
      file => file.fileType === FileType.PO
    ) ?? false;
  }

  get isPDCFileUploaded(): boolean {
    return this.attachments?.some(
      file => file.fileType === FileType.PDC
    ) ?? false;
  }

  get isPdcDetailsUploaded(): boolean {
    return (this.attachments?.some(
      file => file.fileType === FileType.PDC
    ) &&
    this.pdcDetailsForm.get('pdcAmount')?.value &&
    Number(this.pdcDetailsForm.get('pdcAmount')?.value) > 0 &&
    this.pdcDetailsForm.get('dueDate')?.value) ?? false;
  }

  get isPoDetailsValid(): boolean {
    return !!(
      this.pdcDetailsForm?.get('poNumber')?.value &&
      this.pdcDetailsForm?.get('poDate')?.value
    );
  }
}
